const TRACKERS = {
  PROJECT_EXPORTED: "Project-Exported",
  EXPORT_INITIATED: "Export-Initiated",
  EXPORT_BTN_YOUTUBE_CLICKED: "Export-Btn-Youtube-Clicked",
  EXPORT_BTN_DOWNLOAD_CLICKED: "Export-Btn-Download-Clicked",
  EXPORT_BTN_TIKTOK_CLICKED: "Export-Btn-TikTok-Clicked",
  VIEW_SHORTS_PROJECT_PAGE: "View_Shorts_Project_Page",
  SHORTS_EDIT_AS_PROJECT_FLOW_EDITING_SCREEN: "Shorts_Edit_as_Project_Flow_Editing_Screen",
  EXPORT_FROM_EDITOR: "Export_from_Editor",
  UPGRADE_FROM_EDITOR: "Upgrade_from_Editor",
  EXPORT_TO_YOUTUBE: "Export_to_Youtube",
  EXPORT_TO_TIKTOK: "Export_to_Tiktok",
  EXPORT_TO_INSTAGRAM: "Export_to_Instagram",
  DIRECT_DOWNLOAD: "Direct_Download",
  REMOVE_WATERMARK_FROM_EXPORT: "Remove_Watermark_From_Export",
  EXPORT_TO_EDIT: "Export_to_Edit",
  PRICING_FROM_EDITOR: "Pricing_from_Editor",
  DASHBOARD_FROM_EXPORT: "Dashboard_from_Export",
  SUPPORT_FROM_EDITOR: "Support_from_Editor",
  SELECT_QUALITY: "Select_Quality",
  FILE_TYPE: "FileType",
  SUBTITLE_TOGGLE: "Subtitle_Toggle",
  FINAL_DOWNLOAD_EXPORT: "Final_Download_Export",
};

export const TRACKER_PAGES = {
  SHORT_CLIPS: "Short Clips Page",
};

export default TRACKERS;